import { PropsWithChildren, useContext } from 'react';

import { Icons, Tooltip, Box, Stack, tokens } from '@cast/design-system';

import { useOverrideGroup } from './OverrideGroupProvider';
import { WorkloadDetailsContext } from '../../../_context';

export const OverrideGroupPencilLabel = ({ children }: PropsWithChildren) => {
  const { isOverriddenInput, canOverride } = useOverrideGroup();
  const { workload } = useContext(WorkloadDetailsContext);

  if (!isOverriddenInput.value) {
    return <>{children}</>;
  }
  return (
    <Stack component="span" flexDirection="row" gap={4} alignItems="center">
      {children}

      <Tooltip
        title="This setting has been overridden outside the console. To make changes, update it through the same method used to override it."
        placement="right"
        wrapIf={workload?.isManagedByAnnotations || !canOverride}
        color="secondary"
      >
        <Box
          justifyContent="center"
          alignItems="center"
          display="inline-flex"
          bgcolor={tokens.theme.bg.structural.surfaceRaised}
          color={tokens.theme.fg.structural.primary}
          borderRadius="12px"
          fontSize={12}
          p={1}
          data-testid="override-group-pencil-label"
        >
          <Icons.CastHorizontalLinkDash weight="bold" />
        </Box>
      </Tooltip>
    </Stack>
  );
};
